export default "__VITE_ASSET__UKLLDFXN__"